import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetTimeOffSummary(userId) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/timeoff/summary/${userId}`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetCurrentLeave(userId) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/timeoff/current/${userId}`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetPendingTimeOff() {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/timeoff/pending`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetCurrentlyOut() {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/timeoff/currently-out`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetTimeOffOverlaps(userId, startDate, endDate, excludeId) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/timeoff/overlaps`,
        params: { user: userId, startDate, endDate, ...(excludeId ? { exclude: excludeId } : {}) },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestAddTimeOff(userId, startDate, endDate, days, type, description) {
    return axios.request({
        method: "post",
        url: `${getApiUrl()}/timeoff`,
        data: { userId, startDate, endDate, days, type, description },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestEditTimeOff(id, startDate, endDate, days, type, description) {
    return axios.request({
        method: "put",
        url: `${getApiUrl()}/timeoff/${id}`,
        data: { startDate, endDate, days, type, description },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestReviewTimeOff(id, status) {
    return axios.request({
        method: "put",
        url: `${getApiUrl()}/timeoff/review/${id}`,
        data: { status },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeleteTimeOff(id) {
    return axios.request({
        method: "delete",
        url: `${getApiUrl()}/timeoff/${id}`,
        withCredentials: true,
        crossorigin: true,
    });
}
